import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import SEOHead from "../components/SEOHead";

/**
 * Single-use email-verification landing page.
 * URL: /auth/verify-email?token=<raw>
 * Burns the token on mount via POST /api/auth/verify-email.
 */
export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | ok | error

  useEffect(() => {
    if (!token) { setState("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="container-x py-24 max-w-md text-center" data-testid="verify-email-page">
      <SEOHead title="Verify email | Sri Durga Foods" description="Confirm your Sri Durga Foods email address." noindex />
      {state === "loading" && (
        <>
          <Loader2 className="w-10 h-10 animate-spin mx-auto text-brand-chili mb-4" />
          <p className="text-brand-muted">Verifying your email…</p>
        </>
      )}
      {state === "ok" && (
        <>
          <CheckCircle2 className="w-14 h-14 text-emerald-600 mx-auto mb-4" />
          <h1 className="font-serif text-3xl text-brand-dark mb-2">Email verified</h1>
          <p className="text-brand-muted mb-6">Your email is now confirmed. You can sign in.</p>
          <button onClick={() => navigate("/login")} className="btn-primary" data-testid="verify-email-signin">Go to sign in</button>
        </>
      )}
      {state === "error" && (
        <>
          <XCircle className="w-14 h-14 text-brand-chili mx-auto mb-4" />
          <h1 className="font-serif text-3xl text-brand-dark mb-2">Verification failed</h1>
          <p className="text-brand-muted mb-6">This verification link is invalid or has expired. Sign in to request a fresh one.</p>
          <button onClick={() => navigate("/login")} className="btn-primary" data-testid="verify-email-retry">Back to sign in</button>
        </>
      )}
    </div>
  );
}
